import ReportLayoutHeader from '@app/components/reports/components/report-layout-header';
import { soldGoodsRoutes } from '@app/sold-goods/sold-goods-routes';
import { useDownloadOperationReportResults } from '@shared/api/hooks/reports/reports';
import { OperationReportTypeEnum } from '@shared/api/types';
import { downloadCSV } from '@shared/lib/utils';
import sentry from '@shared/services/sentry';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { useSalesReportResult } from '../sales-report-result-context';

export default function SalesReportLayoutHeader() {
  const {
    result: { reportUuid, title },
  } = useSalesReportResult();
  const [isDownloadCSV, setIsDownloadCSV] = useState(false);
  const { data, refetch } = useDownloadOperationReportResults(reportUuid, {
    enabled: isDownloadCSV,
  });

  async function handleDownloadCSV() {
    setIsDownloadCSV(true);
    const res = await refetch();
    try {
      const CSVdata = data || res.data;
      downloadCSV(CSVdata, `${title}.csv`);
    } catch (error) {
      sentry.log(error);
    } finally {
      setIsDownloadCSV(false);
    }
  }

  const handleDownloadPDF = () => {
    const path = generatePath(soldGoodsRoutes.SALES_REPORT_DOWNLOAD, {
      report_uuid: reportUuid,
    });
    window.open(path, '_blank');
  };

  return (
    <ReportLayoutHeader
      reportType={OperationReportTypeEnum.sales}
      reportUuid={reportUuid}
      handleDownloadCSV={handleDownloadCSV}
      handleDownloadPDF={handleDownloadPDF}
      isDownloadCSV={isDownloadCSV}
    />
  );
}
